<template>
	<div>
		<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
			@sort-change="changeTableSort" size="mini" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="stu_idx" v-if="showidx" label="编号" width="60"></el-table-column>
			<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
			<!-- <el-table-column prop="archive" label="建档号" width="120"></el-table-column> -->


			<el-table-column prop="gender" label="性别" width="60">
				<template slot-scope="scope">

					<span v-if="scope.row.gender==1">男</span>
					<span v-if="scope.row.gender==2">女</span>

					<span v-if="scope.row.gender==0">未知</span>
				</template>
			</el-table-column>
			<el-table-column prop="exam_num" label="准考证号" width="100">
				<template slot-scope="scope">

					<span style="color: #006699; cursor: pointer;"
						@click="showZkz(scope.row)">{{scope.row.exam_num}}</span>

				</template>
			</el-table-column>
			<el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>

			<el-table-column prop="major_name" label="报考专业" min-width="140">
				<template slot-scope="scope">
					<span>{{scope.row.major_name}}[{{scope.row.xuezhi}}]{{scope.row.remark}}</span>

				</template>
			</el-table-column>


			<el-table-column prop="phone" label="联系方式" min-width="120">
				<template slot-scope="scope">
					<span>{{scope.row.phone||scope.row.jhr1phone}}</span>

				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status==1" style="color: green;">已审核</span>
					<span v-if="scope.row.status==2" style="color: blue;">已缴费</span>
					<span v-if="scope.row.status==3" style="color: deepskyblue;">已录取</span>
					<span v-if="scope.row.status==4" style="color: #096DD9;">已分班</span>
					<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
					<span v-if="scope.row.status==0" style="color: gray;">未审核</span>
				</template>
			</el-table-column>
			<el-table-column prop="username" label="审核员" width="100"></el-table-column>
			<el-table-column prop="cdate" label="提交时间" width="150"></el-table-column>



			<el-table-column fixed="right" label="操作" width="140" v-if="$store.state.teacherRole.isadmin">
				<template slot-scope="scope">
					<el-button v-if="scope.row.status>=1&&$store.state.pmid==4" @click="printView(scope.row)"
						type="text" size="small">打印</el-button>
					<el-button v-if="scope.row.status<1&&$store.state.pmid!=2" @click="handleModify(scope.row)"
						type="text" size="small">审核</el-button>
					<el-button v-if="scope.row.status<1&&$store.state.pmid==5" @click="handleModify(scope.row)"
						type="text" size="small">审核</el-button>
					<el-button v-if="scope.row.status==1" @click="handleView(scope.row)" type="text" size="small">详情
					</el-button>

					<a v-if="$store.state.teacherRole.isadmin&&$store.state.pmid!=2" @click="handleDel(scope.row)"
						size="small" style="color: red;font-size: 12px;margin-left: 10px; cursor: pointer;">删除</a>


				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
			:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
			layout="total, prev, pager, next, sizes, jumper">
		</el-pagination>

		<zkz :stuid="stuIdx" v-if="stuIdx"></zkz>


	</div>
</template>
<script>
	import zkz from "./zkzPrint.vue"

	export default {
		name: 'Table',
		components: {
			zkz
		},
		data() {
			return {
				stuIdx: 0,
				printAll: false
			}
		},
		props: {
			page: {
				type: Object,
			},
			tableData: {
				type: Array,
				default: []
			},
			from: {
				type: String,
				default: ''
			},
			multSelect: {
				type: Boolean,
				default: true
			},
			showidx: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			handleModify(row) {
				this.$emit('handleModify', row)
			},
			handleView(row) {
				this.$emit('handleView', row)
			},
			handleDel(row) {
				let msg = "";
				if(row.status==1){
					msg="该学生已审核通过，是否确认删除所有有数据？"
				}else{
					msg="确认删除该学生？"
				}
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$emit('handleDel', row)
					
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
			},
			handleSelectionChange(val) {
				this.$emit('handleSelectionChange', val)
			},
			handlePageChange(e) {
				this.$emit('handlePageChange', e)
			},
			handleSizeChange(e) {
				this.$emit('handleSizeChange', e)
			},
			printView(e) {
				this.$emit('printView', e)
			},
			changeTableSort(column) {
				this.$emit('changeTableSort', column)

			},
			showZkz(row) {
				this.stuIdx = row.id
			},

		}
	}
</script>
